import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DialogData} from "@Common/widgets/general/dialog-validation";
import {UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators} from "@angular/forms";
import {SafeHtml} from "@angular/platform-browser";
import {OpinionRequesterCopyRecipients} from "../../../../gestion/reponses/reponse-fiche/request-opinion/opinion-requester.model";
import {ResponseStateInstruction} from "../models";

@Component({
  selector: 'app-modal-instruction-motif',
  templateUrl: './modal-instruction-motif.component.html',
  styleUrls: ['./modal-instruction-motif.component.scss']
})
export class ModalInstructionMotifComponent implements OnInit {
  dialogData: DialogData = new DialogData();
  iconPrefix: SafeHtml = '';
  ready = false;
  form: UntypedFormGroup;
  contentData: string;
  max = 100000;
  responseStateInstruction = ResponseStateInstruction;
  constructor(@Inject(MAT_DIALOG_DATA) public data: { data: DialogData, formId: number, stateToChange: ResponseStateInstruction },
              public dialogRef: MatDialogRef<ModalInstructionMotifComponent>,
              private fb: UntypedFormBuilder) {
    this.contentData = data.data.contentData;

    if (data) {
      this.dialogData = data.data;
    }
  }
  ngOnInit() {
    const validators: ValidatorFn[] = [Validators.maxLength(this.max)];
    const min = this.dialogData.contentMinLength || 0;
    if (min) {
      validators.unshift(Validators.required);
      validators.push(Validators.minLength(min));
    }
    this.form = this.fb.group({
      contentData: [this.contentData, validators],
      confirm: true,
      personsInCopy: [],
    });
    this.ready = true;
  }
  isDisabled() {
    if (this.dialogData.disableButton) {
      return !this.form.valid;
    }
    return false;
  }
  listPersonInCopy(personList: OpinionRequesterCopyRecipients[]) {
    this.form.patchValue({ personsInCopy: personList });
  }
  save() {
    this.dialogRef.close(this.form.value);
  }
}
